import { render } from "./Three.vue?vue&type=template&id=6472aa90"
import script from "./Three.vue?vue&type=script&lang=js"
export * from "./Three.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__